export const formatToBase64 = (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = error => reject(error);
    } else {
      resolve(null);
    }
  });
};
